import { render, staticRenderFns } from "./ArrowCollapseVertical.vue?vue&type=template&id=0e5823a6"
import script from "./ArrowCollapseVertical.vue?vue&type=script&lang=js"
export * from "./ArrowCollapseVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports